import React from 'react';
import { Home, Building2, Wrench, Lock, Key, Shield, Phone } from 'lucide-react';
import { services, businessInfo } from '../data/mock';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const iconMap = {
  Home,
  Building2,
  Wrench,
  Lock,
  Key,
  Shield
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-amber-600 font-semibold text-sm uppercase tracking-wider mb-3">
            What We Offer
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            Our Locksmith Services
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Professional locksmith solutions for homes and businesses throughout South Perth
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group bg-white border-slate-200 hover:border-amber-400 hover:shadow-xl transition-all duration-300 cursor-pointer"
              >
                <CardContent className="p-6">
                  <div className="w-14 h-14 bg-amber-100 group-hover:bg-amber-500 rounded-xl flex items-center justify-center mb-5 transition-colors duration-300">
                    <IconComponent className="w-7 h-7 text-amber-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-amber-600 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-slate-600 mb-4">Need help with your locks?</p>
          <a href={businessInfo.phoneLink}>
            <Button size="lg" className="bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold gap-2 px-8">
              <Phone className="w-5 h-5" />
              Call {businessInfo.phone}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
